<template>
  <div
    class="boost-book"
    :class="{ 'boost-book-open': isOpen }"
    @click="toggleOpen"
  >
    <v-container grid-list-md fluid pa-0>
      <v-layout row wrap>
        <v-flex md12 class="boost-book-flex">
          <div class="boost-book-image">
            <img :src="imageUrl" class="boost-book-image-img" />
            &nbsp;
          </div>
          <div class="boost-book-content">
            <div class="boost-book-title">Boost Your Book</div>
            <div class="boost-book-inner">
              <div class="boost-book-p">
                You're currently looking for 1 reader for your book. The more
                readers you're looking for at a time, the faster Pubby can find
                you interested readers.
              </div>
              <div class="boost-book-p">
                If you're looking for at least 3 readers, you can Boost Your
                Book. We'll show your book higher on our library pages until we
                find the 4 readers you're looking for right now.
              </div>
              <div class="boost-book-p">
                Boosted books typically find readers 35% faster.
              </div>
              <div class="boost-book-action">
                <div
                  class="action grow"
                  :class="{
                    'is-disabled': notEnoughReaders,
                  }"
                  @click="actionClicked"
                >
                  Boost My Book
                </div>
                <div
                  class="confirm-text confirm-text-enabled"
                  v-if="!notEnoughReaders"
                >
                  Costs 200 snaps.
                </div>
                <div
                  class="confirm-text confirm-text-disabled"
                  v-if="notEnoughReaders"
                >
                  You need to be looking for at least 3 readers to use Boost
                  Your Book.
                </div>
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <!-- You're currently looking for 1 reader for your book. The more readers
          you're looking for at a time, the faster Pubby can find you interested
          readers. If you have at least 3 readers, you can Boost Your Book. When
          you use this feature, we'll show your book higher on our library pages
          until we find the 4 readers you're looking for right now. Boosted
          books typically find readers 50% faster than average. Boosting your
          book will subtract 150 snaps from your account to use. -->
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {
  name: "BoostYourBook",
  components: {},
  props: ["assignments"],
  data: function () {
    return {
      imageUrl: null,
      isOpen: false,
      notEnoughReaders: false,
    };
  },
  created() {},
  mounted() {
    this.imageUrl = "/images/publish.png";

    this.notEnoughReaders = this.assignments.length < 3;
    this.notEnoughReaders = this.assignments.length < 1;
  },
  methods: {
    toggleOpen() {
      this.isOpen = true;
    },
    actionClicked() {},
  },
};
</script>

<style lang="scss" scoped>
.content {
  font-size: 12pt;
  padding-bottom: 12px !important;
  padding-left: 0 !important;
}
.review-open .content {
  padding-top: 22px;
  //padding-bottom: 4px !important;
}

.estimate {
  padding-bottom: 12px;
  font-size: 11.5pt;
  color: #555;
}
.estimate p {
  padding: 0 !important;
  margin: 0 !important;
  margin-bottom: 2px !important;
}

.boost-book {
  width: 260px;
  background: #fff;
  border: 0px solid #333;
  //box-shadow: 0px 1px 0.5rem rgba(116, 75, 75, 0.25);
  margin: 0 0px 8px auto;

  padding: 8px 20px 14px 20px;
  border-radius: 8px;
  font-family: "Source Sans Pro";
  transition: all 0.2s ease-in-out;

  .boost-book-flex {
    display: flex;
  }

  .boost-book-image {
    width: 50px;
    max-width: 50px;
    //flex: 0;
    //height: 100px;
    //background: #ddd;
  }
  .boost-book-content {
    flex: 1;
    padding-top: 6px;
    padding-left: 8px;

    .boost-book-title {
      font-size: 11.5pt;
      font-weight: 700;
      text-transform: uppercase;
      letter-spacing: 1px;
      color: #111;
      text-align: center;
      border-bottom: 2px solid #eee;
    }
  }

  .boost-book-image-img {
    width: 40px;
  }

  .boost-book-image-number {
    position: absolute;
    width: 28px;
    height: 28px;
    top: 46px;
    left: 46px;
    background-color: #fdead0;
    padding-top: 1px;
    color: #f57c00;
    font-weight: 700;
    font-family: $font-family;
    font-size: 12pt;
    border-radius: 100px;
    text-align: center;
  }

  .boost-book-inner {
    display: none;
    padding-top: 6px;
  }

  .boost-book-p {
    font-size: 12pt;
    padding: 0.25em 0;
  }
}

.boost-book-open {
  width: 85% !important;
  max-width: 540px !important;

  .boost-book-inner {
    display: block !important;
  }
}

.is-disabled {
  background: #eee !important;
  color: #777 !important;
}
</style>
